module.exports = __webpack_public_path__ + "assets/img/ytzq.890996ed.png";